import { render } from "./Syainedit.vue?vue&type=template&id=f83cda70&ts=true"
import script from "./Syainedit.vue?vue&type=script&lang=ts"
export * from "./Syainedit.vue?vue&type=script&lang=ts"

import "./Syainedit.vue?vue&type=style&index=0&id=f83cda70&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__